import { NON_BOOLEAN_VALUE } from '../constants';
function startsAsObject(value) {
  try {
    if (value.charAt(0) === '{') {
      return true;
    }
  } catch (e) {
    return false;
  }
  return false;
}
function isObject(value) {
  return value && typeof value === 'object' && value.constructor === Object;
}
function isString(input) {
  let result;
  try {
    result = typeof input === 'string' || input instanceof String;
  } catch (err) {
    // swallow any errors
    result = false;
  }
  return result;
}
export function shouldRedactValue(value) {
  return isString(value) && startsAsObject(value) || isObject(value);
}
export function redactValue(featureFlagValue) {
  return shouldRedactValue(featureFlagValue) ? NON_BOOLEAN_VALUE : featureFlagValue;
}